module.exports = __webpack_public_path__ + "static/media/phillip-plein.c43b1b93.svg";